import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { IStatefulCellAdapter } from "../IStatefulCellAdapter";
import { StringAdapter } from "../StringAdapter";
import { ColumnDefinition } from "../../model/ColumnDefinition";

// String types that are sortable as an Int32 in C++ module
export class DealtIntentAdapter extends StringAdapter {
  constructor() {
    super();
  }

  retrieveData(order: any, columnProperty: string): string {
    if (CubiqTS.RequestOrderType.CALL === order.requestedOrderType) {
      return "CALL";
    }
    switch (order[columnProperty]) {
      case CubiqTS.OrderIntent.BUY:
        return '<span class="order-intent-buy">' + "Buy" + "</span>";
      case CubiqTS.OrderIntent.SELL:
        return '<span class="order-intent-sell">' + "Sell" + "</span>";
    }
    return "";
  }

  retrieveSearch(order: any, columnProperty: string): any {
    if (CubiqTS.RequestOrderType.CALL === order.requestedOrderType) {
      return "CALL";
    }
    switch (order[columnProperty]) {
      case CubiqTS.OrderIntent.BUY:
        return "Buy";
      case CubiqTS.OrderIntent.SELL:
        return "Sell";
    }
    return "";
  }

  retrieveSort(order: any, columnProperty: string): string {
    let sortKey: string = this.retrieveSearch(order, columnProperty);
    return sortKey != null ? sortKey.toLowerCase() : "";
  }
}
